// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UuKRF","icon":"styles_icon__1JYmt"};